const configuredBaseUrl = process.env.VUE_APP_VIDEO_BASE_URL;
const videoBaseUrl = configuredBaseUrl
  ? configuredBaseUrl.replace(/\/+$/, "")
  : "/videos";

export function videoUrl(filename: string): string {
  return `${videoBaseUrl}/${filename.replace(/^\/+/, "")}`;
}
